import {
  SET_SNACKBAR,
  SHOW_SNACKBAR,
  SET_PAGE,
  SHOW_MODAL_QUESTION
} from './grappi.types';
import { AnyAction, Reducer } from 'redux';
import { Pages } from 'models/pages.enum';
import { GrappiState } from 'models/redux/grappi.state';

const initialState: GrappiState = {
  enqueueSnackbar: undefined,
  selectedPage:
    (localStorage.getItem('selectedPage') as Pages) || Pages.Operations,
  modalQuestion: undefined
};

const reducer: Reducer<GrappiState> = (
  state: GrappiState = initialState,
  action: AnyAction = { type: undefined }
) => {
  switch (action.type) {
    case SET_SNACKBAR:
    case SET_PAGE:
    case SHOW_MODAL_QUESTION:
      return { ...state, ...action.payload };

    case SHOW_SNACKBAR:
      return { ...state };

    default:
      return state;
  }
};

export default reducer;
